
const pageHistory = {
  state: {
    cashHistory: {} // 缓存页面数据
  },
  mutations: {
    // 记录缓存页面数据，如{ 'mes/basedata/productionLine': {a:1} }
    setCashHistory(state, cashHistory) {
      if (cashHistory?.path) {
        state.cashHistory[cashHistory?.path] = cashHistory?.data;
      }
    },
    // 删除单个缓存
    delItemCache(state, path) {
      if (path && state.cashHistory[path]) {
        delete state.cashHistory[path];
      }
    },
    // 批量删除缓存
    batchDelCache(state, pathList) {
      pathList.forEach(path => {
        if (path && state.cashHistory[path]) {
          delete state.cashHistory[path];
        }
      })
    },
    // 清空缓存数据
    clearCashHistory(state) {
      state.cashHistory = {};
    }
  }
}

export default pageHistory
